import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Input.styles';

const Input = props => {
  const { styles: customStyles, ...rest } = props;
  return <input className={css(styles.base, customStyles)} {...rest} />;
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/inputs/input/Input.js